// extracted by mini-css-extract-plugin
export default {"subgrid":"subgrid__fW2ngSii","title":"title__TRDBJncl"};